import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.333 7.9375V16.9375",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5757 12.9375L12.333 17.1801L8.0904 12.9375",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.833 5.18925C18.7815 6.52325 20.833 9.4908 20.833 12.9375C20.833 17.6319 17.0274 21.4375 12.333 21.4375C7.63859 21.4375 3.83301 17.6319 3.83301 12.9375C3.83301 9.49079 5.88449 6.52322 8.83303 5.18923L8.83302 3.56711C5.03635 4.98584 2.33301 8.64597 2.33301 12.9375C2.33301 18.4604 6.81016 22.9375 12.333 22.9375C17.8559 22.9375 22.333 18.4604 22.333 12.9375C22.333 8.64598 19.6297 4.98586 15.833 3.56712L15.833 5.18925Z",
			fill: "currentColor"
		})
	]
});
export default SvgDownload;
